import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { agentKeyAtom } from 'views/Findings/state';

import {
  checkedListAtom,
  isCheckAllAtom,
  orderByAtom,
  paginationConfigAtom,
  searchPhraseFilterAtom,
  selectedCloudAgentsFilterAtom,
  serverOrWorkstationFilterAtom,
} from './CAList/state';
import { caTypeAtom, appliedCAIdsAtom } from '../CADashboard/state';

export function useOnCompanyChangeCAResetAtoms() {
  const resetSelectedCAIds = useResetAtom(appliedCAIdsAtom);
  const resetCaTypeAtom = useResetAtom(caTypeAtom);
  const resetOrderbyAtom = useResetAtom(orderByAtom);
  const resetServerOrWorkstationAtom = useResetAtom(
    serverOrWorkstationFilterAtom,
  );
  const resetCheckedListAtom = useResetAtom(checkedListAtom);
  const resetIsCheckAllAtom = useResetAtom(isCheckAllAtom);
  const resetSearchPhraseAtom = useResetAtom(searchPhraseFilterAtom);
  const resetSelectedCloudAgentsFilterAtom = useResetAtom(
    selectedCloudAgentsFilterAtom,
  );
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const resetAgentKeyAtom = useResetAtom(agentKeyAtom);

  const resetAtoms = () => {
    resetSelectedCAIds();
    resetCaTypeAtom();
    resetOrderbyAtom();
    resetServerOrWorkstationAtom();
    resetCheckedListAtom();
    resetIsCheckAllAtom();
    resetSearchPhraseAtom();
    resetSelectedCloudAgentsFilterAtom();
    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
    resetAgentKeyAtom();
  };

  return resetAtoms;
}
